export default function handleMFASuccess() {
  const params = new URLSearchParams(window.location.search);

  const redirectUri = params.get('redirect');

  if (redirectUri) {
    window.location.assign(redirectUri);
  } else {
    // Extract react-router state for redirect
    const originPath = window.history.state?.state.pathname;

    // Manually alter history to match redirect
    window.history.pushState(null, '', originPath);

    // Dispatch popstate event to trigger appropriate response from react-router.
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
}
